import styled from "styled-components";

export const Caption = styled.div`
  font-size: 22px;
  color: #333;
  font-weight: 400;
`;

export const ModalContent = styled.div`
  padding: 50px 60px;
  display: flex;
  flex-direction: column;
`;

export const StyledImage = styled.img`
  width: 300px;
`;

export const ContentRow = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;

export const ActionButtons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  > p {
    width: 250px;
    margin: 0;
  }
`;

export const StyledLink = styled.a`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background-color: transparent;
  border: 2px solid #032e68;
  border-radius: 10px;
  color: #032e68;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
    color: #032e68;
  }
  &:focus {
    outline: none;
  }
`;
